<template>
  <div class="relative-position">
    <slot/>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div
        v-if="show"
        :class="[`absolute-top fit q-pa-${padding}`, { blackout }, absoluteContainerClass]"
      >
        <div class="relative-position fit">
          <slot name="controls"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'OverlayControls',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: 'md',
      validator: (value) => ['none', 'xs', 'sm', 'md', 'lg', 'xl'].includes(value),
    },
    blackout: {
      type: Boolean,
      default: false,
    },
    absoluteContainerClass: {
      type: [String, Array],
      default: undefined,
    },
  },
};
</script>

<style scoped lang="scss">
.blackout:before {
  position: absolute;
  content: '';
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
